var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "passenger-picker-accordion" }, [
    _c(
      "div",
      {
        staticClass: "tab",
        attrs: { "aria-expanded": _vm.items.length > 0 ? "true" : "false" }
      },
      [
        _c("div", [
          _c("p", { staticClass: "pax-type" }, [
            _vm._v(_vm._s(_vm.accordionLabel))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "pax-age" }, [
            _vm._v(_vm._s(_vm.accordionSubLabel))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "controls" }, [
          _c("img", {
            class: {
              disabled: _vm.items.length <= _vm.minimumNumberOfPassengersByType
            },
            attrs: {
              alt: "Remove" + _vm.accordionLabel,
              "aria-disabled":
                _vm.items.length <= _vm.minimumNumberOfPassengersByType
                  ? "true"
                  : "false",
              src:
                "//flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/minus-active.svg",
              role: "button",
              tabindex:
                _vm.items.length <= _vm.minimumNumberOfPassengersByType
                  ? "-1"
                  : "0"
            },
            on: {
              click: function($event) {
                _vm.minimumNumberOfPassengersByType < _vm.items.length
                  ? _vm.addNumberOfPassengers(-1)
                  : null
              },
              keypress: function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.minimumNumberOfPassengersByType < _vm.items.length
                  ? _vm.addNumberOfPassengers(-1)
                  : null
              }
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "count" }, [_vm._v(_vm._s(_vm.items.length))]),
          _vm._v(" "),
          _c("img", {
            class: { disabled: !_vm.canAddPassengers },
            attrs: {
              alt: "Add" + _vm.accordionLabel,
              "aria-disabled": !_vm.canAddPassengers ? "true" : "false",
              src:
                "//flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/plus-active.svg",
              role: "button",
              tabindex: "0"
            },
            on: {
              click: function($event) {
                _vm.canAddPassengers ? _vm.addNumberOfPassengers(1) : null
              },
              keypress: function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.canAddPassengers ? _vm.addNumberOfPassengers(1) : null
              }
            }
          })
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.items.length > 0,
            expression: "items.length > 0"
          }
        ],
        staticClass: "tab-inputs"
      },
      _vm._l(_vm.items, function(input, index) {
        return _c(
          "f9field",
          {
            key: _vm.inputLabel + (index + 1),
            attrs: { label: _vm.inputLabel + " " + (index + 1) + " Age" }
          },
          [
            _c(
              "f9select2",
              {
                attrs: {
                  name: _vm.accordionLabel,
                  value: _vm.accordionLabel === "Adults" ? 35 : 0,
                  width: "86px"
                },
                on: { input: _vm.emitInput },
                model: {
                  value: _vm.items[index],
                  callback: function($$v) {
                    _vm.$set(_vm.items, index, $$v)
                  },
                  expression: "items[index]"
                }
              },
              _vm._l(_vm.inputOptions, function(age, index) {
                return _c(
                  "option",
                  {
                    key: index,
                    domProps: { value: age === "100+" ? "100" : age }
                  },
                  [_vm._v(_vm._s(age))]
                )
              })
            )
          ],
          1
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15dcfdf5", { render: render, staticRenderFns: staticRenderFns })
  }
}